// user
export const SET_USER_AUTH_HEADER = 'SET_USER_AUTH_HEADER'
export const SET_DATA_USER = 'SET_DATA_USER'
export const SET_FLUSH_USER = 'SET_FLUSH_USER'
export const SET_USER_REGISTRATIONS = 'SET_USER_REGISTRATIONS'
export const SET_USER_DRIVERS = 'SET_USER_DRIVERS'
export const SET_USER_PARTNERS = 'SET_USER_PARTNERS'
export const SET_USER_PROFILES = 'SET_USER_PROFILES'
export const SET_STORES = 'SET_STORES'

// loading
export const START_LOADING = 'START_LOADING'
export const STOP_LOADING = 'STOP_LOADING'
export const APPLY_FULLSCREEN = 'APPLY_FULLSCREEN'
export const APPLY_COMPONENT = 'APPLY_COMPONENT'

// notification
export const START_NOTIFICATION = 'START_NOTIFICATION'
export const STOP_NOTIFICATION = 'STOP_NOTIFICATION'

// modal
export const START_MODAL = 'START_MODAL'
export const STOP_MODAL = 'STOP_MODAL'
export const LAUNCH_MODAL = 'LAUNCH_MODAL'
export const CLEAN_MODAL = 'CLEAN_MODAL'

// orders
export const SET_ORDERS_OPEN = 'SET_ORDERS_OPEN'
export const SET_FLUSH_ORDERS = 'SET_FLUSH_ORDERS'
export const SET_SELECTED_PAGE = 'SET_FLUSH_ORDERS'
export const RESET_SELECTED_PAGE = 'RESET_SELECTED_PAGE'

// filters
export const SET_SELECTED_SORT = 'SET_SELECTED_SORT'
export const SET_ORDER_FILTERS = 'SET_ORDER_FILTERS'
export const SET_FLUSH_USER_FILTERS = 'SET_FLUSH_USER_FILTERS'
export const SET_FLUSH_FILTERS = 'SET_FLUSH_FILTERS'
export const SET_SELECTED_DELIVERYDATA = 'SET_SELECTED_DELIVERYDATA'
export const SET_INCIDENCES = 'SET_INCIDENCES'
export const SET_RESCHEDULES = 'SET_RESCHEDULES'
export const SET_SELECTED_ORDERID = 'SET_SELECTED_ORDERID'
export const SET_SCHEDULES = 'SET_SCHEDULES'
export const SET_STORES_FILTERS = 'SET_STORES_FILTERS'
export const SET_SELECTED_STORE = 'SET_SELECTED_STORE'
export const SET_SELECTED_ORDERBO = 'SET_SELECTED_ORDERBO'
export const SET_STATES = 'SET_STATES'
export const SET_SELECTED_ORDERSTATE = 'SET_SELECTED_ORDERSTATE'
export const SET_SELECTED_PROMISSEDATA = 'SET_SELECTED_PROMISSEDATA'
export const SET_SELECTED_COLLECTIONDATA = 'SET_SELECTED_COLLECTIONDATA'
export const SET_SELECTED_ORD = 'SET_SELECTED_ORD'
export const SET_PODS = 'SET_PODS'

// messages
export const LAUNCH_MAILBOX_MODAL = 'LAUNCH_MAILBOX_MODAL'
export const SET_FLUSH_MAILBOX_MODAL = 'SET_FLUSH_MAILBOX_MODAL'
export const START_MAILBOX_MODAL = 'START_MAILBOX_MODAL'
export const STOP_MAILBOX_MODAL = 'STOP_MAILBOX_MODAL'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js